import { useState, useEffect } from 'react';

const breakpoints = {
    sm: 640,
    md: 768,
    lg: 1024,
    xl: 1280,
    '2xl': 1536,
};

export const useResponsive = () => {
    const [isMobile, setIsMobile] = useState(false);
    const [isTablet, setIsTablet] = useState(false);
    const [isDesktop, setIsDesktop] = useState(false);
    const [isLargeDesktop, setIsLargeDesktop] = useState(false);

    useEffect(() => {
        const handleResize = () => {
            const width = window.innerWidth;

            setIsMobile(width < breakpoints.sm);
            setIsTablet(width >= breakpoints.sm && width < breakpoints.lg);
            setIsDesktop(width >= breakpoints.lg && width < breakpoints.xl);
            setIsLargeDesktop(width >= breakpoints.xl);
        };

        handleResize();

        window.addEventListener('resize', handleResize);

        return () => window.removeEventListener('resize', handleResize);
    }, []);

    return { isMobile, isTablet, isDesktop, isLargeDesktop };
};
